








import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class FooterComponent extends Vue {
  @Prop({
    default: true
  })
  created() {}

  hideFooter() {
    const elem = document.getElementById("footer");
    if (elem != null) elem.classList.add("off");
  }
}
